import styles from '../common/Section.module.scss'

import { Anchor, Flex, Group, Icon, theme } from '@percent/lemonade'

type OrganisationLinkProps = {
  organisationId: string
  name: string
}

export function OrganisationLink({ organisationId, name }: Readonly<OrganisationLinkProps>) {
  return (
    <Anchor
      href={`/organizations/${organisationId}`}
      target="_blank"
      rel="noreferrer"
      underline="hover"
      display="inline-flex"
      className={styles.organisationLink}
    >
      <Group gap={theme.spacing.xxs} wrap="nowrap">
        {name}
        {/* Decorative: the link text already names the organisation, so keep the icon out of the accessible name. */}
        <Flex aria-hidden align="center">
          <Icon name="external-link" size={3} color="inherit" />
        </Flex>
      </Group>
    </Anchor>
  )
}
